




















































































import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatYearsMonthDay, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { deepCopy } from "@/lib/utility/deep-copy";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { WorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import repairEstimateRequestService from "@/services/mrfiktiv/services/repair-estimate-request.service";
import { MrfiktivRepairEstimateRequestViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import FileInput from "../utility/FileInput.vue";

@Component({
  components: {
    ConfirmActionDialog,
    FileInput
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateRequestResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  value!: MrfiktivRepairEstimateRequestViewModelGen;

  @Prop()
  token!: string;

  valueCopy = deepCopy(this.value);

  isDialogActive = false;

  loading = false;

  isValid = false;

  file: File | null = null;

  get dateFormable(): string {
    if (!this.valueCopy.date) {
      return "";
    }
    return formatYearsMonthDay(new Date(this.valueCopy.date));
  }

  set dateFormable(date: string) {
    if (date) {
      this.valueCopy.date = new Date(date).toISOString();
    }

    this.valueCopy.date = date;
  }

  open() {
    this.valueCopy = deepCopy(this.value);
    if (!this.valueCopy.workshopRate) {
      this.valueCopy.workshopRate = new WorkshopContractRate();
    }

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  async confirmRepairEstimateResponse() {
    if (!this.file || !this.valueCopy.number || !this.valueCopy.total || !this.valueCopy.date) {
      this.$toast.error(this.$t("repairEstimateRequest.response.missingFields"));
      return;
    }

    this.loading = true;
    try {
      const response = await repairEstimateRequestService.respond(this.value.partnerId, this.value.id, this.token, {
        total: this.valueCopy.total,
        number: this.valueCopy.number,
        date: this.valueCopy.date,
        file: this.file
      });
      this.$emit("input", response);
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("repairEstimateRequest.response.success"));
      this.loading = false;
      this.close();
    }
  }

  @Watch("file", { deep: true })
  onFileChange(file: File) {
    if (file) {
      if (!this.valueCopy.number) {
        this.valueCopy.number = file.name;
      }
    }
  }
}
